export default __webpack_public_path__ + "static/media/splash.1f6e855a.svg";